document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-main-nav]');
  if (toggle && nav) toggle.addEventListener('click', function () { nav.classList.toggle('open'); });
  // Product gallery thumbnails
  var main = document.querySelector('[data-product-main-image]');
  if (main) document.querySelectorAll('[data-product-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      main.src = t.dataset.fullSrc || t.src;
      main.removeAttribute('srcset');
      if (t.dataset.ar) main.classList.toggle('img--contain', parseFloat(t.dataset.ar) < 0.85);
    });
  });
  // Variant picker -> update price + selected variant id for the product form
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var dataEl = document.querySelector('[data-product-json]');
    if (dataEl) {
      var product = JSON.parse(dataEl.textContent);
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = document.querySelector('[data-product-price]');
      var submit = form.querySelector('button[type="submit"]');
      function money(cents) { return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
      function refresh() {
        var chosen = [];
        form.querySelectorAll('[data-option-group]').forEach(function (g) {
          var checked = g.querySelector('input:checked'); chosen.push(checked ? checked.value : null);
          var label = g.querySelector('[data-option-value]');
          if (label && checked) label.textContent = checked.value;
        });
        var variant = product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return chosen[i] === null || opt === chosen[i]; });
        });
        if (!variant) return;
        idInput.value = variant.id;
        if (priceEl) {
          priceEl.innerHTML = (variant.compare_at_price && variant.compare_at_price > variant.price ? '<s>' + money(variant.compare_at_price) + '</s> ' : '') + money(variant.price);
        }
        if (submit) { submit.disabled = !variant.available; submit.textContent = variant.available ? submit.dataset.addText : 'Sold out'; }
        if (main && variant.featured_image) {
          main.src = variant.featured_image.src;
          main.removeAttribute('srcset');
          if (variant.featured_image.width && variant.featured_image.height) {
            main.classList.toggle('img--contain', (variant.featured_image.width / variant.featured_image.height) < 0.85);
          }
        }
        var url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
      }
      var params = new URLSearchParams(window.location.search);
      var vid = params.get('variant');
      form.querySelectorAll('[data-option-group]').forEach(function (g) { g.addEventListener('change', refresh); });
      if (vid) { var v = product.variants.find(function (x) { return String(x.id) === vid; }); if (v) { form.querySelectorAll('[data-option-group]').forEach(function (g, gi) { var inp = g.querySelector('input[value="' + CSS.escape(v.options[gi]) + '"]'); if (inp) inp.checked = true; }); } }
      refresh();
    }
  }
});

  var exps = document.querySelectorAll('[data-nav-exp]');
  for (var e = 0; e < exps.length; e++) {
    exps[e].addEventListener('click', function () {
      var item = this.closest('.main-nav__item');
      var wasOpen = item.classList.contains('sub-open');
      var openItems = document.querySelectorAll('.main-nav__item.sub-open');
      for (var o = 0; o < openItems.length; o++) {
        openItems[o].classList.remove('sub-open');
        var b = openItems[o].querySelector('[data-nav-exp]');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
      if (!wasOpen) { item.classList.add('sub-open'); this.setAttribute('aria-expanded', 'true'); }
    });
  }
